import React, { useEffect, useState } from "react";
import { Badge, Card, Col, Container, Form, InputGroup, ListGroup, Row, Spinner, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SplitPane from "react-split-pane";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studyEventFormSchemaServices } from "../../../../APIServices/studyEventFormSchemaServices";
import { studyEventManagementServices } from "../../../../APIServices/CTMS/EventManagement/studyEventManagementServices";
import { studyMedicalReviewServices } from "../../../../APIServices/studyMedicalReviewServices";
import Swal from "sweetalert2";
import { BsBuildingsFill, BsCheck2All, BsClock, BsEye, BsFileText } from "react-icons/bs";
import { PiWarning } from "react-icons/pi";
import ReviewStatusDistribution from "./ReviewStatusDistribution";
import CompletionbyForm from "./CompletionbyForm";
import ReviewerPerformance from "./ReviewerPerformance";
import { CiSearch } from "react-icons/ci";
import UseToggle from "../../../../Hooks/UseToggle";
import FilterSubjectMedicalTask from "./FilterSubjectMedicalTask";
import Pagination from "../../../Pagination";
import ReviewQueryHistory from "../../FormManagement/FormList/ReviewQueryHistory";
import QueryStatusDistribution from "./QueryStatusDistribution";

const TaskSummery = ({ onMouseDown, tableRef, handleAddNewTab }) => {
  const [taskList, setTaskList] = useState([]);
  const [taskCount, setTaskCount] = useState(0);
  const [taskAnalytics, setTaskAnalytics] = useState("");
  const [siteId, setSiteId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [loading, setLoading] = useState(false);
  const [taskLoading, setTaskLoading] = useState(false);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [taskData, setTaskData] = useState("");
  const [type, setType] = useState("ALL");
  const toggles = UseToggle();

  const studyPermission = JSON.parse(localStorage.getItem("studyPermissionData"));
  const dataType = (StudyMode === "Live Mode" || StudyMode === "QC Mode") ? ((studyPermission?.liveSummeryMedicalReview || studyPermission?.qcSummeryMedicalReview) ? "ALL" : "MY") : (StudyMode === "SDV Live Mode" || StudyMode === "SDV QC Mode") ? ((studyPermission?.liveSDVSummeryMedicalReview || studyPermission?.qcSDVSummeryMedicalReview) ? "ALL" : "MY") : "MY"

  const getSubjectMedicalReviewTaskStatus = async () => {
    setLoading(true);
    let data = await studyMedicalReviewServices.getSubjectMedicalReviewTaskStatus(
      studyId,
      "edc",
      type,
      dataType,
      StudyMode,
      siteId,
      subjectId,
    );
    setTaskList(data?.data || []);
    setTaskCount(data?.count || 0);
    setLoading(false);
  };

  const getTaskManagementAnalytics = async () => {
    setTaskLoading(true)
    let data = await studyMedicalReviewServices.getTaskManagementAnalytics(studyId, type, dataType, StudyMode)
    setTaskAnalytics(data?.data || "")
    setTaskLoading(false)
  }

  const isOverdue = (dateString) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const givenDate = new Date(dateString);
    givenDate.setHours(0, 0, 0, 0);

    return givenDate < today ? "Yes" : "No";
  };

  const completedOverviewCards = [
    {
      title: "Total Tasks",
      value: taskAnalytics?.totalTask,
      subtitle: "Completed review activities",
      icon: <BsFileText className="bg-white text-info shadow-sm" />,
    },
    {
      title: "Avg. Turnaround",
      value: taskAnalytics?.avgTurnaround,
      subtitle: "Average review completion time",
      icon: <BsClock className="bg-white text-warning shadow-sm" />,
    },
    {
      title: "Review Complete",
      value: taskAnalytics?.completedReview,
      subtitle: "Successfully finalized reviews",
      icon: <BsCheck2All className="bg-white text-success shadow-sm" />,
    },
    {
      title: "Open Queries",
      value: taskAnalytics?.totalOpenComment,
      subtitle: "Awaiting resolution",
      icon: <PiWarning className="bg-white text-danger shadow-sm" />,
    },
  ];

  useEffect(() => {
    getSubjectMedicalReviewTaskStatus();
  }, [studyId, type, dataType, siteId, subjectId]);

  useEffect(() => {
    getTaskManagementAnalytics();
  }, [studyId, type, dataType]);

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <InputGroup className="w-auto">
          <button onClick={() => setType("ALL")} className={`updateProfile ${type === "ALL" ? "activee" : ""}`}>
            All
          </button>
          <button onClick={() => setType("7D")} className={`updateProfile ${type === "7D" ? "activee" : ""}`}>
            7D
          </button>
          <button onClick={() => setType("30D")} className={`updateProfile ${type === "30D" ? "activee" : ""}`}>
            30D
          </button>
          <button onClick={() => setType("QTD")} className={`updateProfile ${type === "QTD" ? "activee" : ""}`}>
            QTD
          </button>
        </InputGroup>
        <button className="updateProfile">Export</button>
      </div>
      <SplitPane
        split="vertical"
        minSize={"100%"}
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
      >
        {taskLoading ? (
          <PageLoader />
        ) : (
          <>
            <>
              <div className="p-2 chart__overview hstack justify-content-between gap-3">
                {completedOverviewCards?.map((item, index) => (
                  <div key={index} className="h-100 w-100">
                    <Card className="app-card bg-light border">
                      <Card.Body>
                        <div className="d-flex gap-3">
                          <div className="study_icopn">{item.icon}</div>
                          <div>
                            <Card.Title style={{ fontSize: 16 }}>{item.title}</Card.Title>
                            <Card.Text className="m-0">
                              {item.value}
                            </Card.Text>
                            <Card.Text style={{ fontSize: 11 }}>{item.subtitle}</Card.Text>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                ))}
              </div>
              <Container fluid className="pb-3">
                <Row className="g-2">
                  <Col md={4}>
                    <ReviewStatusDistribution
                      taskAnalytics={taskAnalytics}
                    />
                  </Col>
                  <Col md={4}>
                    <QueryStatusDistribution
                      taskAnalytics={taskAnalytics}
                    />
                  </Col>
                  <Col md={4}>
                    <CompletionbyForm dataType={dataType} />
                  </Col>
                  <Col md={12}>
                    <ReviewerPerformance
                      onMouseDown={onMouseDown}
                      tableRef={tableRef}
                      dataType={dataType}
                    />
                  </Col>
                </Row>
              </Container>
            </>
            {loading ? (
              <PageLoader />
            ) : taskList?.length === 0 ? "" : (
              <>
                <div
                  className="justify-content-between toolbar border-bottom border-top hstack p-1"
                  style={{ height: 36 }}
                >
                  <div className="hstack gap-1">
                    <i className="fa slid fa-filter" onClick={() => toggles.setToggle()}></i>
                  </div>
                </div>
                <Table ref={tableRef} className="m-0 custom-table" hover striped>
                  <thead className="position-sticky top-0 z-1">
                    <tr>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 0)}
                        style={{ width: 45 }}
                        className="text-center"
                      >
                        Sr.
                      </th>

                      <th onMouseDown={(e) => onMouseDown(e, 1)}>Site Id</th>

                      <th onMouseDown={(e) => onMouseDown(e, 2)}>Subject Id</th>

                      <th onMouseDown={(e) => onMouseDown(e, 3)}>Total Form</th>

                      <th onMouseDown={(e) => onMouseDown(e, 5)}>Passed Review</th>

                      <th onMouseDown={(e) => onMouseDown(e, 6)}>Failed Review</th>

                      <th onMouseDown={(e) => onMouseDown(e, 7)}>Pending Review</th>

                    </tr>
                  </thead>

                  <tbody>
                    {taskList?.map((metadata, index) => (
                      <tr key={index}>
                        <td className="text-center">{index + 1}</td>

                        <td>{metadata?.siteName}</td>

                        <td>{metadata?.subjectName}</td>

                        <td>{metadata?.totalFormCount}</td>

                        <td>{metadata?.completedFormCount}</td>

                        <td>{metadata?.rejectedFormCount}</td>

                        <td>{metadata?.pendingFormCount}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            )}
          </>
        )}
      </SplitPane>
      <FilterSubjectMedicalTask
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        Title={"Filter"}
        siteId={siteId}
        setSiteId={setSiteId}
        subjectId={subjectId}
        setSubjectId={setSubjectId}
        loading={loading}
        getSubjectMedicalReviewTaskStatus={getSubjectMedicalReviewTaskStatus}
      />
    </>
  );
};

export default TaskSummery;
